export enum CommonUserGroups {
    ROLTEK = 'Roltek',
    ROLTEK_AT = 'Roltek AT',
}
